import { apiGet } from './client';

export interface VoicePresetLite {
  id: string;
  name: string;
  base_voice: string;
}

interface ListResponse {
  presets: VoicePresetLite[];
}

export async function listVoicePresets(): Promise<VoicePresetLite[]> {
  const res = await apiGet<ListResponse>('/api/voice-presets');
  return res.presets ?? [];
}
